import React from "react";
import CreatorDetails from "../../../pages/ChangeRequest/activities/creatorDetails";
import { ucFirst } from "../../../helpers/string_helper";
import { Action } from "../../../constants/Common";
import { Modules } from "../../../constants/Module";
import ArrowRightAltOutlinedIcon from "@mui/icons-material/ArrowRightAltOutlined";
import { DeliverableStatus, ProjectStatuses } from "../../../constants/Status";
import moment from "moment";
import { withTranslation } from "react-i18next";
function Deliverable({ item, t}) {
  return (
    <div>
      <div>
        <strong>
          {" "}
          {ucFirst(Modules.DELIVERABLE)} ({typeof item?.payload?.name === 'object' ? item?.payload?.name.old : item?.payload?.name}){" "}
        </strong>
         {item.event === Action.CREATE ? t("was added to") : item.event === Action.UPDATE ? t("was updated for") : t("was deleted from")}{" "}
        <strong>
          {t('startup')} {ucFirst(item.project?.name)} (
          {item?.project?.uniqueProjectId})
        </strong>{" "}
        {t('by')}
        <CreatorDetails creator={item?.creator} date={item?.createdAt} />
      </div>
      {item?.event === Action?.UPDATE && (
        <div>
          {/* {item?.payload?.currentStatus &&
            typeof item?.payload?.currentStatus === "object" && (
              <div className="mx-2">
                <div className="d-flex align-items-center change_status">
                  {item?.payload?.currentStatus?.new ===
                    DeliverableStatus.REJECTED && (
                    <div className="d-flex align-items-center change_status">
                      <span>
                        Deliverable {item?.payload?.name} is rejected by{" "}
                        <strong>
                          {item?.creator?.projectUsers[0]?.role?.name} [
                          {item?.creator?.name} | {item?.creator?.uniqueUserId}]
                        </strong>
                      </span>
                    </div>
                  )}
                  {item?.payload?.currentStatus?.new === ProjectStatuses.ONGOING && (
                    <div className="d-flex align-items-center change_status">
                      <span>
                        Deliverable {item?.payload?.name} is approved by{" "}
                        <strong>
                          {item?.creator?.projectUsers[0]?.role?.name} [
                          {item?.creator?.name} | {item?.creator?.uniqueUserId}]
                        </strong>
                      </span>
                    </div>
                  )}
                  {item?.payload?.currentStatus?.new ===
                    DeliverableStatus.IN_APPROVAL && (
                    <div className="d-flex align-items-center change_status">
                      <span>
                        Deliverable {item?.payload?.name} is{" "}
                        {item?.payload?.status?.old === ProjectStatuses.DRAFT
                          ? "sent for approval"
                          : "re-submitted"}{" "}
                        by{" "}
                        <strong>
                          {item?.creator?.projectUsers[0]?.role?.name} [
                          {item?.creator?.name} | {item?.creator?.uniqueUserId}]
                        </strong>
                      </span>
                    </div>
                  )}
                </div>
              </div>
            )} */}
            {typeof item?.payload?.currentStatus === "object" &&
            item?.payload?.currentStatus?.old &&
            item?.payload?.currentStatus?.new && (
              <div className="mx-2">
                <div className="d-flex align-items-center change_status">
                  <strong> {t('Status')}: </strong>
                  <div className="d-flex align-items-center mx-2">
                    <span>{item?.payload?.currentStatus?.old}</span>
                  </div>
                  <span className="middleArrow mx-2">
                    <ArrowRightAltOutlinedIcon />
                  </span>
                  <div className="d-flex align-items-center">
                    <span className="mx-2">{item?.payload?.currentStatus?.new}</span>
                  </div>
                </div>
              </div>
            )}
          {typeof item?.payload?.name === 'object' &&
            item?.payload?.name?.old &&
            item?.payload?.name?.new && (
              <div className="mx-2">
                <div className="d-flex align-items-center change_status">
                  <strong> {t('Name')}: </strong>
                  <div className="d-flex align-items-center mx-2">
                    <span>{item?.payload?.name?.old}</span>
                  </div>
                  <span className="middleArrow mx-2">
                    <ArrowRightAltOutlinedIcon />
                  </span>
                  <div className="d-flex align-items-center">
                    <span className="mx-2">{item?.payload?.name?.new}</span>
                  </div>
                </div>
              </div>
            )}
          {typeof item?.payload?.expectedOutput === "object" && (
            <div className="mx-2">
              <div className="d-flex align-items-center change_status">
                <strong> {t('Expected Output')}:</strong>
                <div className="d-flex align-items-center mx-2">
                  <span>{item?.payload?.expectedOutput?.old ?? "N/A"}</span>
                </div>
                <span className="middleArrow mx-2">
                  <ArrowRightAltOutlinedIcon />
                </span>
                <div className="d-flex align-items-center">
                  <span className="mx-2">
                    {item?.payload?.expectedOutput?.new ?? "N/A"}
                  </span>
                </div>
              </div>
            </div>
          )}
          {typeof item?.payload?.description === "object" && (
            <div className="mx-2">
              <div className="d-flex align-items-center change_status">
                <strong> {t('Description')}: </strong>
                <div className="d-flex align-items-center mx-2">
                  <span>{item?.payload?.description?.old ?? "N/A"}</span>
                </div>
                <span className="middleArrow mx-2">
                  <ArrowRightAltOutlinedIcon />
                </span>
                <div className="d-flex align-items-center">
                  <span className="mx-2">
                    {item?.payload?.description?.new ?? "N/A"}
                  </span>
                </div>
              </div>
            </div>
          )}
          {item?.payload?.cost && typeof item?.payload?.cost === "object" &&
            item?.payload?.cost?.old >= 0 &&
            item?.payload?.cost?.new >= 0 && (
              <div className="mx-2">
                <div className="d-flex align-items-center change_status">
                  <strong> {t('Cost')}: </strong>
                  <div className="d-flex align-items-center mx-2">
                    <span>
                      {parseFloat(item?.payload?.cost?.old).toFixed(2)}
                    </span>
                  </div>
                  <span className="middleArrow mx-2">
                    <ArrowRightAltOutlinedIcon />
                  </span>
                  <div className="d-flex align-items-center">
                    <span className="mx-2">
                      {parseFloat(item?.payload?.cost?.new).toFixed(2)}
                    </span>
                  </div>
                </div>
              </div>
            )}
          {typeof item?.payload?.weight === "object" && 
          item?.payload?.weight?.old >= 0 &&
          item?.payload?.weight?.new >= 0 && (
            <div className="mx-2">
              <div className="d-flex align-items-center change_status">
                <strong> {t('Weight')}: </strong>
                <div className="d-flex align-items-center mx-2">
                  <span>{item?.payload?.weight?.old}</span>
                </div>
                <span className="middleArrow mx-2">
                  <ArrowRightAltOutlinedIcon />
                </span>
                <div className="d-flex align-items-center">
                  <span className="mx-2">{item?.payload?.weight?.new}</span>
                </div>
              </div>
            </div>
          )}
          {item?.payload?.startDate &&
            item?.payload?.startDate?.old &&
            item?.payload?.startDate?.new && (
              <div className="mx-2">
                <div className="d-flex align-items-center change_status">
                  <strong> {t('Start Date')}: </strong>
                  <div className="d-flex align-items-center mx-2">
                    <span>{moment(item?.payload?.startDate?.old).format("Do MMMM, YYYY")}</span>
                  </div>
                  <span className="middleArrow mx-2">
                    <ArrowRightAltOutlinedIcon />
                  </span>
                  <div className="d-flex align-items-center">
                    <span className="mx-2">
                    {moment(item?.payload?.startDate?.new).format("Do MMMM, YYYY")}
                    </span>
                  </div>
                </div>
              </div>
            )}
          {item?.payload?.endDate &&
            item?.payload?.endDate?.old &&
            item?.payload?.endDate?.new && (
              <div className="mx-2">
                <div className="d-flex align-items-center change_status">
                  <strong> {t('End Date')}: </strong>
                  <div className="d-flex align-items-center mx-2">
                    <span>{moment(item?.payload?.endDate?.old).format("Do MMMM, YYYY")}</span>
                  </div>
                  <span className="middleArrow mx-2">
                    <ArrowRightAltOutlinedIcon />
                  </span>
                  <div className="d-flex align-items-center">
                    <span className="mx-2">{moment(item?.payload?.endDate?.new).format("Do MMMM, YYYY")}</span>
                  </div>
                </div>
              </div>
            )}
        </div>
      )}
    </div>
  );
}
export default withTranslation()(Deliverable);